import { Empty } from "../components/ui";
function Unavailable({ title }: { title: string }) { return <><span className="kicker">Community</span><h1 style={{marginTop:18}}>{title}</h1><Empty>Community reads and actions are unavailable in this public V2 frontend.</Empty></>; }
export function Boards(){return <Unavailable title="Boards are unavailable"/>}
export function BoardPage(){return <Unavailable title="Board is unavailable"/>}
export function ThreadPage(){return <Unavailable title="Thread is unavailable"/>}
